import PersonalDetail from './person-detail'

export default PersonalDetail